import React, { useEffect, useRef } from 'react';
import { Animated, Dimensions, Easing, Platform, StyleProp, View, ViewStyle } from 'react-native';
import { colors } from '../../../utils/theme';

export type IndeterminateLoadingBarOwnProps = {
    style: StyleProp<ViewStyle>;
    barStyle?: StyleProp<ViewStyle>;
};

export type IndeterminateLoadingBarProps = IndeterminateLoadingBarOwnProps;

const IndeterminateLoadingBar: React.FC<IndeterminateLoadingBarProps> = (props) => {
    const animation = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        Animated.loop(
            Animated.sequence([
                Animated.timing(animation, {
                    toValue: 1,
                    duration: 1500,
                    easing: Easing.linear,
                    useNativeDriver: Platform.OS === 'web',
                }),
                Animated.timing(animation, {
                    toValue: 0,
                    duration: 0,
                    useNativeDriver: Platform.OS === 'web',
                }),
            ]),
        ).start();
    }, [animation]);

    const windowWidth = Dimensions.get('window').width;
    const translateX = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [windowWidth * -1, windowWidth * 2],
    });

    return (
        <View style={[{ overflow: 'hidden' }, props.style]}>
            <Animated.View
                style={[
                    { height: '100%', width: '30%', backgroundColor: colors.Primary },
                    { transform: [{ translateX }] },
                    props.barStyle,
                ]}
            />
        </View>
    );
};

export default React.memo(IndeterminateLoadingBar);
